import React from 'react'
import { Route, Switch } from 'react-router-dom'

import DashboardApp from './components/Dashboard/App'
import ProfileApp from './components/Profile/App'
import ClientsApp from './components/Clients/App'
import ProjectsApp from './components/Projects/App'
import ProjectApp from './components/Project/App'
import TasksIssuesApp from './components/TasksIssues/App'
import TasksDiagramApp from './components/TasksDiagram/App'
import TimesheetApp from './components/Timesheet/App'
import TimeDiagramApp from './components/TimeDiagram/App'
import AdminApp from './components/Admin/App'
import SettingsApp from './components/Settings/App'
import AdminDashboardTimesheetApp from './components/AdminDashboard/Timesheet/App'
import AdminDashboardProjectApp from './components/AdminDashboard/Project/App'
import AdminDashboardSettingsApp from './components/AdminDashboard/Settings/App'

const router = () => (
    <Switch>
        <Route path="/" exact component={Dashboard} />

        <Route path="/Dashboard" component={Dashboard} />
        <Route path="/Profile" component={Profile} />
        <Route path="/Clients" component={Clients} />

        <Route path="/Projects" component={Projects} />
        <Route path="/Project/:id" component={Project} />

        <Route path="/TasksIssues" component={TasksIssues} />
        <Route path="/TasksDiagram" component={TasksDiagram} />
        <Route path="/Timesheet" component={Timesheet} />
        <Route path="/TimeDiagram" component={TimeDiagram} />

        <Route path="/Admin" component={Admin} />
        <Route path="/Settings" component={Settings} />
        <Route path="/AdminDashboardTimesheet" component={AdminDashboardTimesheet} />
        <Route path="/AdminDashboardProject" component={AdminDashboardProject} />
        <Route path="/AdminDashboardSettings" component={AdminDashboardSettings} />
    </Switch>
)

const Dashboard = () => (
    <DashboardApp />
)
const Profile = () => (
    <ProfileApp />
)
const Clients = () => (
    <ClientsApp />
)
const Projects = () => (
    <ProjectsApp />
)
const Project = ({ match }) => (
    <ProjectApp ProjectId={match.params.id} />
)
const TasksIssues = () => (
    <TasksIssuesApp />
)
const TasksDiagram = () => (
    <TasksDiagramApp />
)
const Timesheet = () => (
    <TimesheetApp />
)
const TimeDiagram = () => (
    <TimeDiagramApp />
)
const Admin = () => (
    <AdminApp />
)
const Settings = () => (
    <SettingsApp />
)
const AdminDashboardTimesheet = () => (
    <AdminDashboardTimesheetApp />
)
const AdminDashboardProject = () => (
    <AdminDashboardProjectApp />
)
const AdminDashboardSettings = () => (
    <AdminDashboardSettingsApp />
)

export default router



// WEBPACK FOOTER //
// ./src/router.js